import Divider from 'flow/components/ui-components/Divider';
import DropdownMenuComponent from 'flow/components/ui-components/DropdownMenuComponent';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';
import React, { MouseEventHandler } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';
import Page from '../../Page';
import { Delay as DelayLogic } from '../components/CallSettings';
import formatDuration from '../functions/formatDuration';
import onUpdate from '../functions/onUpdate';

interface Props {
    profile: TypedMap<Profile>;
    onClickBack: MouseEventHandler;
}

interface Params {
    profileKey: ProfileKey | 'profile';
    extensionKey: ExtensionKey;
}

const Delay = ({ profile, onClickBack }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { profileKey, extensionKey } = useParams<Params>();
    const initialDelays = [5, 10, 15, 20, 25, 30, 45, 60, 90, 120];
    const { profiles } = useProfiles(extensionKey);

    return (
        <Page
            onClickBack={onClickBack}
            header="settings.incoming_calls.delayed"
        >
            <DelayLogic profile={profile} />

            <Divider />

            <DropdownMenuComponent
                title={`${i18next.t(
                    'settings.incoming_calls.delayed.time',
                )} ( ${formatDuration(
                    profile.getIn(['callForwarding', 'secondsOfDelay']),
                )} )`}
                options={initialDelays.map((item) => ({
                    key: item.toString(),
                    label: formatDuration(item),
                }))}
                onItemSelected={(value) =>
                    dispatch(
                        onUpdate(
                            extensionKey,
                            profileKey,
                            [
                                {
                                    state: ['callForwarding', 'secondsOfDelay'],
                                    value: value,
                                },
                            ],
                            profiles,
                        ),
                    )
                }
            />
        </Page>
    );
};

export default Delay;
